export const GOTO_STEP = 'GOTO_STEP';
export const EDIT_MODE = 'EDIT_MODE';
export const SUBMIT_ENTITY_FORM = 'SUBMIT_ENTITY_FORM';
export const SUBMIT_BUSINESS_INFO_FORM = 'SUBMIT_BUSINESS_INFO_FORM';
export const SUBMIT_BANK_INFO_FORM = 'SUBMIT_BANK_INFO_FORM';
export const SUBMIT_BUSINESS_DOCUMENT_FORM = 'SUBMIT_BUSINESS_DOCUMENT_FORM';
export const BUSINESS_DATA = 'BUSINESS_DATA';
export const KYB_DATA = 'KYB_DATA';
export const KYB_BANK_DATA = 'KYB_BANK_DATA';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const ID_CARD = 'ID_CARD';
export const RESET_CITY_DROPDOWN = 'RESET_CITY_DROPDOWN';
export const RESET_KECAMATAN_DROPDOWN = 'RESET_KECAMATAN_DROPDOWN';
export const RESET_ZIPCODE_DROPDOWN = 'RESET_ZIPCODE_DROPDOWN';
export const KYB_IDENTITY_DATA = 'KYB_IDENTITY_DATA';
export const CONFIRM_REVIEW = 'CONFIRM_REVIEW';
export const NPWP_IMAGE = 'NPWP_IMAGE';
